// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductCannabis_title__RsUOR","label":"ProductCannabis_label__jLhwy"};